import { some } from 'lodash';

export class TabService {
	private tabs: { [tabViewId: string]: { [tabId: string]: boolean } } = {};

	isActive(tabViewId: string, tabId: string) {
		const view =  this.tabs[tabViewId];

		if (!view) { return false; };

		return view[tabId] || false;
	}

	select(tabViewId: string, tabId: string) {
		let container =  this.tabs[tabViewId];

		if (!container) { this.tabs[tabViewId] = container = {}; }

		for (const i in container) {
			if (!container.hasOwnProperty(i)) { continue; }
			container[i] = false;
		}

		container[tabId] = true;
	}

	anySelected(tabViewId: string, tabId: string) {
		const container =  this.tabs[tabViewId];

		if (!container) { return false; }

		return some(container, tab => tab);
	}
}
